/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxtBuildsV1RepoState } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXT_BUILDS_V1_REPO_STATE_ENTITY_NAME = 'ixt.builds.v1.Repo';
export const ixtBuildsV1RepoStateEntity = new schema.Entity<IxtBuildsV1RepoState>(IXT_BUILDS_V1_REPO_STATE_ENTITY_NAME, {}, { idAttribute: (entity: IxtBuildsV1RepoState) => `${entity.owner}-${entity.name}` });

